import React from "react";
import { Contacts } from "../contacts/contacts";
import { Social } from "../social/social";
import {useStyles} from "./style";
import {ContactsAndSocialProps} from "./types";

export const ContactsAndSocial = (props: ContactsAndSocialProps) => {
  const classes = useStyles();

  return (
    <div className={classes.contactsAndSocialContainer}>
      <Contacts {...props.contactsProps} />
      <Social {...props.socialProps} />
    </div>
  );
};
